import { render } from "./PageIndex.vue?vue&type=template&id=3f5bc48c&scoped=true"
import script from "./PageIndex.vue?vue&type=script&lang=js"
export * from "./PageIndex.vue?vue&type=script&lang=js"

import "./PageIndex.vue?vue&type=style&index=0&id=3f5bc48c&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5bc48c"]])

export default __exports__